module.exports = __webpack_public_path__ + "img/cooperation.e592a8d0.jpg";